import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

import ValidatedInput from "../../components/ValidatedInput/ValidatedInput";
import Typography from "../../components/Typography/Typography";
import RecoverPwsImg from "../../assets/recoverPwsImage.svg";
import Button from "../../components/Button/Button";
import Loader from "../../components/Loader/Loader";
import Modal from "../../components/Modal/Modal";
import AuthPageShell from "../../components/AuthPageShell/AuthPageShell";
import shellStyles from "../../components/AuthPageShell/AuthPageShell.module.scss";
import styles from "./RecoverPws.module.scss";
import codes from "../../utils/codes";

import { ReactComponent as ArrowLeft } from "../../assets/arrowLeft.svg";
import { StateContext } from "../../contexts/state.context";
import { forgotPasswordUser } from "../../utils/services";
import { formatStrNumber } from "../../utils/functions";

const RECAPTCHA_KEY = window.env.REACT_APP_GOOGLE_KEY;
const WHATSAPP_LINK = window.env.REACT_APP_WHATSAPP_LINK;

const RecoverPws = () => {
	const navigate = useNavigate();
	const { setFormData } = useContext(StateContext);

	const [username, setUsername] = useState();
	const [usernameError, setUsernameError] = useState();

	const [email, setEmail] = useState("");

	const [token, setToken] = useState(null);
	const [captchaError, setCaptchaError] = useState(false);

	const [modal, setModal] = useState(false);
	const [notRegisterModal, setNotRegisterModal] = useState(false);

	const [loader, setLoader] = useState(false);

	const handleBackClick = () => {
		navigate("/");
	};

	const handleBtnDisabled = () => {
		if (username && token) return false;
		else return true;
	};

	const handleSendCode = () => {
		if (!username) {
			setUsernameError(true);
			return;
		}

		if (!token) {
			setCaptchaError(true);
			return;
		}

		const rData = {
			userIdentifier: username.replaceAll(".", ""),
			captchaToken: token,
		};

		setLoader(true);

		forgotPasswordUser({ formInfo: rData })
			.then(({ code, message }) => {
				setLoader(false);

				switch (code) {
					case codes.JVB001.code:
						setModal(true);
						setEmail(message.email);
						setFormData({ id: username.replaceAll(".", "") });
						break;

					default:
						setNotRegisterModal(true);
						break;
				}
			})
			.catch((e) => {
				setNotRegisterModal(true);
				setLoader(false);
			});

		//
	};

	const handleCreateAccountRedirect = () => {
		navigate("/register/validate-identity");
	};

	const handleContinue = () => {
		navigate("/forgot-pws-otp");
	};

	return (
		<>
		<AuthPageShell scrollFooterReserve={false}>
			<div className={styles.recoverPwsContainer}>
			<div className={shellStyles.authTitleContainer}>
				<ArrowLeft
					className={shellStyles.authTitleArrow}
					onClick={handleBackClick}
				></ArrowLeft>

				<div className={shellStyles.authTitleTxt}>
					<Typography variant="h5">
						Restablece tu contraseña
					</Typography>
				</div>
			</div>

			<div className={styles.recoverPwsCard}>
				<img
					src={RecoverPwsImg}
					alt="recover-pws-img"
					className={styles.recoverPwsCardImg}
				></img>

				<div className={styles.recoverPwsCardContent}>
					<Typography
						variant="h4"
						className={styles.recoverPwsCardTitle}
					>
						¿Olvidaste tu contraseña?
					</Typography>

					<Typography className={styles.recoverPwsCardTxt}>
						Ingresa tu número de identificación y te enviaremos al{" "}
						<span style={{ fontWeight: "bold" }}>
							correo electrónico registrado
						</span>{" "}
						un código de seis dígitos para{" "}
						<span style={{ fontWeight: "bold" }}>
							restablecer tu contraseña.
						</span>
						.
					</Typography>

					<ValidatedInput
						className={styles.recoverPwsTextInputContainer}
						label="Número de identificación"
						placeholder="Escribe aquí tu número de identificación"
						type="text"
						inputMode="numeric"
						onChange={setUsername}
						error={usernameError}
						setError={setUsernameError}
						formatter={formatStrNumber}
						style={{ textAlign: "center" }}
					></ValidatedInput>

					<div className={styles.recoverPwsReCaptchaContainer}>
						<div className={styles.recoverPwsReCaptcha}>
							<ReCAPTCHA
								sitekey={RECAPTCHA_KEY}
								hl="es"
								onChange={(token) => {
									setCaptchaError(false);
									setToken(token);
								}}
							></ReCAPTCHA>

							{captchaError && (
								<div
									className={styles.recoverPwsReCaptchaBorder}
								>
									<Typography
										className={
											styles.recoverPwsReCaptchaError
										}
										variant="p2"
										color="red"
									>
										Debe realizar el reCAPTCHA
									</Typography>
								</div>
							)}
						</div>
					</div>

					<Button
						className={styles.recoverPwsBtn}
						onClick={handleSendCode}
						disabled={handleBtnDisabled()}
					>
						Enviar código
					</Button>
				</div>
			</div>

			<div onClick={() => navigate("/login")}>
				<Typography className={styles.cacelBtn} variant="h4">
					Cancelar
				</Typography>
			</div>

			{modal && (
				<Modal title="¡Revisa tu correo!">
					<>
						<Typography className={styles.recoverPwsModalTxt}>
							Hemos enviado un correo <br></br> electrónico a{" "}
							<br></br>
							<span className={styles.recoverPwsModalTxtBlue}>
								[{email}]
							</span>{" "}
							<br></br> con un código de seis dígitos para
							restablecer tu contraseña.
						</Typography>

						<Typography className={styles.recoverPwsModalTxt1}>
							Recuerda revisar la carpeta de<br></br>{" "}
							<span className={styles.recoverPwsModalTxtBold}>
								Spam
							</span>{" "}
							o{" "}
							<span className={styles.recoverPwsModalTxtBold}>
								Promociones
							</span>
							.
						</Typography>

						<Button
							className={styles.recoverPwsModalBtn}
							onClick={handleContinue}
						>
							Continuar
						</Button>

						<Typography
							variant="p3"
							className={styles.recoverPwsModalTxt}
						>
							Si no reconoces este correo electrónico,{" "}
							<a
								className={styles.recoverPwsModalTxtUnderline}
								href={WHATSAPP_LINK}
								target="_blank"
								rel="noopener noreferrer"
							>
								contáctanos aquí.
							</a>
						</Typography>
					</>
				</Modal>
			)}

			{notRegisterModal && (
				<Modal title="Número de identificación no encontrado">
					<>
						<Typography className={styles.recoverPwsModalTxt1}>
							Verifica que lo hayas ingresado correctamente. Si
							aún no tienes cuenta, haz clic en “
							<span className={styles.recoverPwsModalTxtBold}>
								Crear cuenta
							</span>
							”.
						</Typography>
						<Button
							className={styles.recoverPwsModalBtn}
							onClick={handleCreateAccountRedirect}
						>
							Crear cuenta
						</Button>

						<div onClick={() => setNotRegisterModal(false)}>
							<Typography
								variant="p3"
								className={styles.recoverPwsModalTxt3}
							>
								Volver
							</Typography>
						</div>
					</>
				</Modal>
			)}

			</div>
		</AuthPageShell>
			{loader && <Loader />}
		</>
	);
};

export default RecoverPws;
